import BoughtItems from './BoughtItems';
import { BoughtItemsFragment } from '../../utils/hooks/getBoughtItems';
import PaginationLinks from '../PaginationLinks';
type BoughtItemsSuccessProps = {
  boughtItems: BoughtItemsFragment;
};

/**
 *
 * The `<BoughtItemsSuccess />` component handles rendering our results and
 * controls for updating the request
 */
export const BoughtItemsSuccess = ({
  boughtItems: {
    purchasesByPage
  }
}: BoughtItemsSuccessProps) => {
  return <>
      <BoughtItems boughtItems={purchasesByPage.edges.map(({
      node
    }) => node)} />
      <PaginationLinks pageCount={purchasesByPage.pageCount} buttonGroupLabel="Pagination for bought items" />
    </>;
};